import { useEffect } from "react";
import "material-symbols";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Area from "./components/Pages/AForluz/Area/Area";
import Comite from "./components/Pages/AForluz/Comite/Comite";
import Conselhos from "./components/Pages/AForluz/Conselhos/Conselhos";
import Estatuto from "./components/Pages/AForluz/Estatudo/Estatuto";
import Historia from "./components/Pages/AForluz/Historia/Historia";
import Home from "./components/Pages/AForluz/Home/RenderHome";
import Missao from "./components/Pages/AForluz/Missao/Missao";
import Numeros from "./components/Pages/AForluz/Numeros/Numeros";
import OrganogramaPage from "./components/Pages/AForluz/Organograma/OrganogramaPage";
import Comunicados from "./components/Pages/AconteceNaForluz/Comunicados";
import Guia from "./components/Pages/AconteceNaForluz/Guia";
import NoticiaCompletaRender from "./components/Pages/AconteceNaForluz/NoticiaCompletaRender";
import NoticiasForluz from "./components/Pages/AconteceNaForluz/Noticias";
import Canais from "./components/Pages/Contato/Canais";
import FaleConosco from "./components/Pages/Contato/FaleConosco";
import Emprestimos from "./components/Pages/Emprestimos/Emprestimos";
import Formularios from "./components/Pages/Formularios";
import CodigoConduta from "./components/Pages/Governanca/CodigoConduta";
import Denuncias from "./components/Pages/Governanca/Denuncias";
import LGPD from "./components/Pages/Governanca/LGPD";
import Manual from "./components/Pages/Governanca/Manual";
import DemostracoesPage from "./components/Pages/Investimentos/Demostracoes";
import PoliticaInvestimento from "./components/Pages/Investimentos/PoliticaInvestimento";
import AtuarialA from "./components/Pages/Planos/Plano A/Atuarial";
import PlanoADescricao from "./components/Pages/Planos/Plano A/Descricao";
import RegulamentoA from "./components/Pages/Planos/Plano A/Regulamento";
import RentabilidadeAPage from "./components/Pages/Planos/Plano A/Rentabilidade";
import AtuarialB from "./components/Pages/Planos/Plano B/Atuarial";
import CartilhasPageB from "./components/Pages/Planos/Plano B/Cartilhas";
import PlanoBDescricao from "./components/Pages/Planos/Plano B/Descricao";
import RegulamentoB from "./components/Pages/Planos/Plano B/Regulamento";
import RentabilidadeBPage from "./components/Pages/Planos/Plano B/Rentabilidade";
import AtuarialTaesa from "./components/Pages/Planos/Plano taesaprev/Atuarial";
import CartilhaTaesa from "./components/Pages/Planos/Plano taesaprev/Cartilhas";
import PlanoTaesaprev from "./components/Pages/Planos/Plano taesaprev/Descricao";
import RegulamentoTaesa from "./components/Pages/Planos/Plano taesaprev/Regulamento";
import RentabilidadeTaesaPage from "./components/Pages/Planos/Plano taesaprev/Rentabilidade";
import Acesso from "./components/Pages/Transparencia/Acesso";
///Plano A/plano-a
import AtualizarDados from "./components/Common/AtualizarDados";
import NotFoundRoute from "./components/Common/NotFound";
import ApresentacoesEspeciais from "./components/Pages/AconteceNaForluz/ApresentacoesEspeciais";
import Publicacoes from "./components/Pages/AconteceNaForluz/Publicacoes";
import RelatorioAnualDeInformacoes from "./components/Pages/AconteceNaForluz/RelatorioAnualDeInformacoes";
import CalendarioBeneficioParticipante from "./components/Pages/AconteceNaForluz/CalendarioBeneficioParticipante";
import PeruntasFrequentes from "./components/Pages/Contato/PerguntasFrequentes";
import TrabalheConosco from "./components/Pages/Contato/TrabalheConosco";
import ResultadoBusaca from "./components/Pages/ResultadoBusca/";
import ExtratoTac from "./components/Pages/Transparencia/ExtratoTAC";
import RelatorioCircunstanciado from "./components/Pages/Transparencia/RelatorioCircunstanciado";
/* é uma copia do Perfil de Investimento B, sendo que vai servir para todos perfils (B e Taesa)... foi removido os links de Perfil do Plano B e Plano Taesa */
import AtracaoeSelecao from "./components/Pages/Contato/AtracaoeSelecao";
import NossasPraticas from "./components/Pages/Contato/NossasPraticas";
import ProgramaCompliance from "./components/Pages/Governanca/ProgramaDeCompliance";
import GuestaoDeRiscaoPage from "./components/Pages/GuestaoDeRiscao/GuestaoDeRiscoPage";
import CalculadoraPage from "./components/Pages/Investimentos/Calculadora";
import CalculadoraContribPage from "./components/Pages/Investimentos/CalculadoraContrib";
import DemostrativoInvestimento from "./components/Pages/Investimentos/DemostrativoInvestimento";
import Demostrativos from "./components/Pages/Investimentos/Demostrativos";
import PerfilInvestimento from "./components/Pages/Investimentos/PerfilInvestimento";
import RelatorioPropositoEspecificoTaesa from "./components/Pages/Planos/Plano taesaprev/PerfilInvestimento";
import RelatorioAnualTransparencia from "./components/Pages/Transparencia/RelatorioAnual";
import RelatorioPropositoEspecifico from "./components/Pages/Transparencia/RelatorioPropositoEspecifico";
import ViverMelhorPage from "./components/Pages/ViverMelhor/ViverMelhorPage";
import CentralFrame from "./components/Pages/CentralDeAtendimento/CentralFrame";
import LavagemTerrorismo from "./components/Pages/Governanca/LavagemTerrorismo";
import CalculadoraDeduzirIR from "./components/Pages/CalculadoraDeduzirIR";
import PlanoGestaoAdministrativa from "./components/Pages/Transparencia/PlanoGestaoAdministrativa";
// import BoxChat from "./components/BoxChat";
// import "./assets/scss/core/_global.scss"

function App() {
  useEffect(() => {}, []);

  return (
    <>
      {/* <BoxChat /> */}
      <Router>
        <Routes>
          <Route path="" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/historia" element={<Historia />} />
          <Route path="/missao" element={<Missao />} />
          <Route path="/organograma" element={<OrganogramaPage />} />
          <Route path="/estatuto" element={<Estatuto />} />
          <Route path="/numeros" element={<Numeros />} />
          <Route path="/conselhos" element={<Conselhos />} />
          <Route path="/comite" element={<Comite />} />
          {/*noticias-internas query string */}
          <Route
            path="/noticias-internas/:id"
            element={<NoticiaCompletaRender />}
          />

          <Route
            path="acontece-na-forluz/publicacoes"
            element={<Publicacoes />}
          />
          <Route path="resultado-busca" element={<ResultadoBusaca />} />

          <Route path="PlanoA/plano-a" element={<PlanoADescricao />} />
          <Route path="PlanoA/plano-a-regulamento" element={<RegulamentoA />} />
          <Route
            path="PlanoA/plano-a-rentabilidades"
            element={<RentabilidadeAPage />}
          />
          <Route path="PlanoA/Demonstracao-Atuarial" element={<AtuarialA />} />
          <Route path="PlanoB/Demonstracao-Atuarial" element={<AtuarialB />} />
          <Route
            path="PlanoB/plano-b-descricao"
            element={<PlanoBDescricao />}
          />
          <Route path="PlanoB/plano-b-regulamento" element={<RegulamentoB />} />
          <Route path="PlanoB/plano-b-cartilha" element={<CartilhasPageB />} />
          <Route
            path="PlanoB/plano-b-rentabilidades"
            element={<RentabilidadeBPage />}
          />
          {/* <Route path="PlanoB/perfil-de-investimento" element={<PerfilInvestimento />} /> */}

          <Route
            path="PlanoTaesaprev/plano-taesaprev-descricao"
            element={<PlanoTaesaprev />}
          />
          <Route
            path="PlanoTaesaprev/plano-taesaprev-regulamento"
            element={<RegulamentoTaesa />}
          />
          <Route
            path="PlanoTaesaprev/plano-taesaprev-cartilha"
            element={<CartilhaTaesa />}
          />
          <Route
            path="PlanoTaesaprev/plano-taesaprev-rentabilidades"
            element={<RentabilidadeTaesaPage />}
          />

          <Route
            path="PlanoTaesaprev/Demonstracao-Atuarial"
            element={<AtuarialTaesa />}
          />
          <Route
            path="PlanoTaesaprev/perfil-de-investimento"
            element={<RelatorioPropositoEspecificoTaesa />}
          />

          <Route
            path="Investimentos/politica-investimentos"
            element={<PoliticaInvestimento />}
          />
          <Route
            path="Investimentos/demonstracoes-financeiras"
            element={<DemostracoesPage />}
          />
          <Route
            path="Investimentos/demonstrativos-contabeis"
            element={<Demostrativos />}
          />
          <Route
            path="Investimentos/demonstrativos-de-investimentos"
            element={<DemostrativoInvestimento />}
          />
          <Route
            path="Investimentos/perfil-de-investimento"
            element={<PerfilInvestimento />}
          />

          <Route
            path="Investimentos/calculadora-de-aporte"
            element={<CalculadoraPage />}
          />
          <Route
            path="Investimentos/calculadora-de-contribuicao"
            element={<CalculadoraContribPage />}
          />

          {/* <Route path="Investimentos/investimentos-por-indexador" element={<Indexador />} /> */}
          {/* Areas */}
          <Route path="/diretoria-executiva" element={<Area />} />
          <Route path="/conselho-deliberativo" element={<Area />} />
          <Route
            path="/gerencia-de-complience-e-governacao-fpr-co"
            element={<Area />}
          />
          <Route path="/conselho-fiscal" element={<Area />} />
          <Route path="/presidencia-fpr" element={<Area />} />
          <Route path="/consultoria-juridica-fpr-cj" element={<Area />} />
          <Route
            path="/gerencia-de-comunicacao-e-atendimento-fpr-ca"
            element={<Area />}
          />
          <Route path="/assessoria-de-risco-fpr-ri " element={<Area />} />
          <Route
            path="/diretoria-de-investimentos-e-controle-fic"
            element={<Area />}
          />
          <Route
            path="/gerencia-de-renda-variavel-de-macroalocação-fic-rv"
            element={<Area />}
          />
          <Route
            path="/gerencia-de-controladoria-e-financas-fic-cf"
            element={<Area />}
          />
          <Route
            path="/gestao-de-renda-fixa-imoveis-e-emprestimos-fic-rf"
            element={<Area />}
          />
          <Route
            path="/diretoria-de-seguridade-e-gestao-fsg"
            element={<Area />}
          />
          <Route
            path="/gerencia-de-atuaria-e-seguridade-fsg-ad"
            element={<Area />}
          />
          <Route
            path="/gerencia-de-tecnologia-da-informacao-fsg-ti"
            element={<Area />}
          />
          <Route
            path="/gerencia-de-recursos-humanos-e-administracao-fsg-ra"
            element={<Area />}
          />
          <Route
            path="/diretoria-de-relacoes-com-participantes-frp"
            element={<Area />}
          />
          {/* ./Areas */}

          <Route
            path="/Governanca/politica-gov-corporativa"
            element={<Manual />}
          />
          <Route
            path="/Governanca/politica-lavagem-terrorismo"
            element={<LavagemTerrorismo />}
          />
          <Route path="/Governanca/codigo-etica" element={<CodigoConduta />} />
          <Route path="/Governanca/lgpd" element={<LGPD />} />
          <Route path="/Governanca/canal-de-denuncia" element={<Denuncias />} />
          <Route
            path="/Governanca/programa-de-compliance"
            element={<ProgramaCompliance />}
          />
          <Route
            path="acontece-na-forluz/noticias"
            element={<NoticiasForluz />}
          />
          <Route
            path="acontece-na-forluz/comunicados"
            element={<Comunicados />}
          />
          <Route path="/Contato/fale-conosco" element={<FaleConosco />} />

          <Route
            path="acontece-na-forluz/guia-participante"
            element={<Guia />}
          />
          <Route
            path="acontece-na-forluz/relatorio-anual-informacoes"
            element={<RelatorioAnualDeInformacoes />}
          />
          <Route
            path="acontece-na-forluz/beneficio-participante"
            element={<CalendarioBeneficioParticipante />}
          />
          <Route
            path="acontece-na-forluz/apresentacoes-especiais"
            element={<ApresentacoesEspeciais />}
          />
          <Route path="/Contato/canais-atendimento" element={<Canais />} />
          <Route
            path="/Contato/perguntas-frequentes"
            element={<PeruntasFrequentes />}
          />
          {/* <Route
            path="/Contato/trabalhe-conosco"
            element={<TrabalheConosco />}
          /> */}
          <Route
            path="/Contato/trabalhe-conosco"
            element={<AtracaoeSelecao />}
          />
          <Route path="/Contato/nossas-praticas" element={<NossasPraticas />} />
          <Route path="emprestimos" element={<Emprestimos />} />
          <Route path="Transparencia/acesso-informacao" element={<Acesso />} />
          <Route path="Transparencia/extrato-tac" element={<ExtratoTac />} />
          <Route
            path="Transparencia/relatorio-anual-informacoes"
            element={<RelatorioAnualTransparencia />}
          />
          <Route path="formularios" element={<Formularios />} />
          <Route
            path="Transparencia/relatorio-circunstanciado"
            element={<RelatorioCircunstanciado />}
          />
          <Route
            path="Transparencia/relatorio-proposito-especifico"
            element={<RelatorioPropositoEspecifico />}
          />
          <Route
            path="Transparencia/plano-de-gestao-administrativa"
            element={<PlanoGestaoAdministrativa />}
          />

          <Route path="gestaoderisco" element={<GuestaoDeRiscaoPage />} />

          <Route
            path="/CentralDeAtendimento/central-atendimento"
            element={<CentralFrame />}
          />

          <Route
            path="ViverMelhor/para-viver-melhor"
            element={<ViverMelhorPage />}
          />

          <Route
            path="/Calculadora/calculadora-deduzir"
            element={<CalculadoraDeduzirIR />}
          />

          {/* Default */}
          <Route path="*" element={<NotFoundRoute />} />
          <Route path="/Atualizar-Dados" element={<AtualizarDados />} />
        </Routes>
      </Router>{" "}
    </>
  );
}

export default App;
